export default __webpack_public_path__ + "static/media/loading.5cfc6754.gif";